export { default } from './getDelay'
